import api from '@/utils/http'

/**
 功能：登录
 time: 2025-13-01 17:13:44
 **/
export function login(data) {
    return api.post('/admin/login/ajaxLogin', data)
}

/**
 功能：退出
 time: 2025-13-01 17:13:47
 **/
export function logout() {
    return api.get('/admin/login/ajaxLogout')
}